/**
 * @require ./_base.js
 */
(function (global) {
    /**
     * @param {string} id
     * @param {{DropZoneSelector: string, Page: any, Form: any=, RestrictToOrganizationUnits: boolean, Placeholders: {Placeholders: [], Map: {}}}} additionalSettings
     * @constructor
     */
    const MailTemplatePlaceholdersWindow = function (id, additionalSettings) {
        if (!id) {
            id = 'mail-template-placeholders';
        }

        if (additionalSettings == null) {
            return;
        }

        this.ID = id;

        if (!!additionalSettings.DropZoneSelector && additionalSettings.Page != null) {
            this.Page = additionalSettings.Page;
            this.DropZoneSelector = additionalSettings.DropZoneSelector;
            this.$dropZoneElements = $(additionalSettings.DropZoneSelector);
        }

        this.Form = additionalSettings.Form;
        this.RestrictToOrganizationUnits = !!additionalSettings.RestrictToOrganizationUnits;
        this.PlaceHoldersList = additionalSettings.Placeholders.Placeholders;
        this.PlaceHoldersMap = additionalSettings.Placeholders.Map;

        this.SearchResult = [];
    };

    function show() {
        if ($(`#${this.ID}`).length > 0) {
            return;
        }

        initPlaceholders.call(this);
        initCheckpoints.call(this);

        const windowMarkup = getWindowMarkup.call(this);
        $('body').append(windowMarkup);

        initWindow.call(this);
        bindEvents.call(this);
        resizeWindow.call(this);

        return this;
    }

    function initWindow() {
        this.$window = $('#' + this.ID);
        this.$header = this.$window.find('h1');
        this.$footer = this.$window.find('.bottom');

        this.$search = this.$window.find('.search');
        this.$placeHoldersList = this.$window.find('.list');
        this.$placeHoldersDescription = this.$window.find('.description');

        initSearch.call(this);
    }

    function initPlaceholders() {
        this.PlaceHoldersList
            .sort(sortByPositionAndTitle)
            .forEach(g => g.children.sort(sortByPositionAndTitle));

        this.CurrentlySelectedPlaceholder = this.PlaceHoldersList[0].children[0];
    }

    function initCheckpoints() {
        this.Checkpoints = {};

        if (this.Form == null) {
            return;
        }

        this.Form.Parametergroups
            .filter(function (group) {
                return group.Enabled &&
                    group.ModificationType !== Enums.ModificationType.Deleted &&
                    (group.Parameters || []).length > 0;
            })
            .forEach(function (group) {
                group.Parameters
                    .filter(function (param) {
                        return param.Enabled &&
                            param.ModificationType !== Enums.ModificationType.Deleted &&
                            param.Type !== Enums.elementType.Info;
                    })
                    .forEach(function (param) {
                        this.Checkpoints[param.OID] = param;
                    }, this)
            }, this);
    }

    function initSearch() {
        const searchOptions = {
            placeholder: i18next.t('changeMode.mailTemplates.placeholdersWindow.search')
        };

        this.Search = this.$search
            .search(searchOptions)
            .search(true);
    }

    function getWindowMarkup() {
        return [
            '<div id="', this.ID, '" class="popup draggable-window">',
                '<h1 class="top">',
                    '<span class="title">', i18next.t('changeMode.mailTemplates.placeholdersWindow.title'), '</span>',
                    '<span class="close"></span>',
                '</h1>',

                '<div class="content">',
                    '<div class="content-message-bubble">',
                        '<div class="content info">',
                            '<p class="text">',
                                i18next.t('changeMode.mailTemplates.placeholdersWindow.infoText'),
                            '</p>',
                        '</div>',
                    '</div>',

                    '<div class="detailed-data-picker">',
                        '<div class="search"></div>',
                        '<div class="grid-row details">',
                            '<ul class="grid-col-6-12 list">',
                                getPlaceholdersListMarkup.call(this),
                            '</ul>',
                            '<div class="grid-col-6-12 description">',
                                getPlaceholderDescriptionMarkup.call(this),
                            '</div>',
                        '</div>',
                    '</div>',
                '</div>',

                '<div class="bottom">',
                    '<div class="flex-dummy"></div>',
                    '<div class="btn-steal btn-close">',
                        i18next.t('changeMode.mailTemplates.placeholdersWindow.close'),
                    '</div>',
                '</div>',
            '</div>'
        ].join('');
    }

    function unbindEvents() {
        this.$header.off('click');
        this.$footer.find('.btn-close').off('click');

        this.$search.off('.search');
        this.$placeHoldersList.off('click');

        $(window).off('resize.resizeMailTemplatePlaceholdersWindow');

        if (this.$dropZoneElements instanceof $) {
            this.$placeHoldersList.find('li')
                .off('dragstart')
                .off('dragend');

            unbindDropZoneEvents.call(this);
        }
    }

    function unbindDropZoneEvents() {
        if (this.$dropZoneElements instanceof $) {
            this.$dropZoneElements
                .off('dragover')
                .off('drop');
        }
    }

    function bindEvents() {
        unbindEvents.call(this);

        this.$header.find('.close').on('click', $.proxy(close, this));
        this.$footer.find('.btn-close').on('click', $.proxy(close, this));

        this.$placeHoldersList.on('click', 'li:not(.item-header):not(.selected)', $.proxy(onClickPlaceholdersListItem, this));

        this.$search
            .on('search.search', $.proxy(onSearchFunction, this))
            .on('select-previous-result.search select-next-result.search', $.proxy(onSelectPreviousOrNextFunction, this));

        $(window)
            .on('resize.resizeMailTemplatePlaceholdersWindow', $.proxy(resizeWindow, this));

        this.$window
            .draggable({
                handle: '.top',
                cancel: '.close',
                appendTo: 'body',
                scroll: false
            });

        if (this.$dropZoneElements instanceof $) {
            this.$placeHoldersList.find('li')
                .on('dragstart', $.proxy(onDragStart, this))
                .on('dragend', $.proxy(onDragEnd, this));
        }
    }

    function bindDropZoneEvents() {
        if (!this.DropZoneSelector || this.Page == null) {
            return;
        }

        unbindDropZoneEvents.call(this);

        this.$dropZoneElements = $(this.DropZoneSelector);

        if (this.$dropZoneElements instanceof $) {
            this.$dropZoneElements
                .on('dragover', $.proxy(onDragOver, this))
                .on('drop', $.proxy(onDrop, this));
        }
    }

    function onDragStart(evt) {
        bindDropZoneEvents.call(this);

        this.DraggedListItem = evt.currentTarget;
        this.DraggedListItem.style.fontWeight = 'bold';

        evt.originalEvent.dataTransfer.effectAllowed = 'move';
        evt.originalEvent.dataTransfer.setData('text/plain', createPlaceholderText.call(this));

        this.$dragOverlay = $('<div class="drag-overlay"></div>');
        $('body').append(this.$dragOverlay);

        this.$dropZoneElements.addClass('drop-visible');
    }

    function createPlaceholderText() {
        if (!this.DraggedListItem) {
            return null;
        }

        const name = this.DraggedListItem.dataset.name;

        if (!name) {
            return null;
        }

        return `{{${name}}}`;
    }

    function onDragOver(evt) {
        if (evt.preventDefault) {
            evt.preventDefault();
        }

        evt.originalEvent.dataTransfer.dropEffect = 'move';

        return false;
    }

    function onDragEnd() {
        this.DraggedListItem.style.fontWeight = 'normal';

        if (this.$dragOverlay) {
            this.$dragOverlay.remove();
            this.$dragOverlay = null;
        }

        this.$dropZoneElements.removeClass('drop-visible');
    }

    function onDrop(evt) {
        if (this.DraggedListItem == null) {
            return;
        }

        const $targetControl = $(evt.currentTarget);
        const $targetItem = $targetControl.parents('.item');
        const pageProperty = this.Page && this.Page.CurrentTab ?
            this.Page.CurrentTab.PropertyMap[$targetItem.attr('id')] :
            null;

        if (!pageProperty) {
            return;
        }

        this.DraggedListItem.style.fontWeight = 'normal';

        if (this.$dragOverlay) {
            this.$dragOverlay.remove();
            this.$dragOverlay = null;
        }

        const dropDataTransfer = (evt.dataTransfer || evt.originalEvent.dataTransfer);

        if ($targetControl.prop('tagName') === 'INPUT' && dropDataTransfer) {
            evt.preventDefault();

            const placeholder = dropDataTransfer.getData('text/plain');

            const input = $targetControl[0];
            const selectionStart = input.selectionStart;
            const selectionEnd = input.selectionEnd;

            const currentValue = input.value;
            input.value = currentValue.slice(0, selectionStart) + placeholder + currentValue.slice(selectionEnd);

            const newPosition = selectionStart + placeholder.length;
            input.setSelectionRange(newPosition, newPosition);

            pageProperty.SetValue(input.value);
        }

        this.$dropZoneElements.removeClass('drop-visible');
        this.Page.CurrentTab.MarkAsModified();
    }

    function getPlaceholdersListMarkup() {
        return this.PlaceHoldersList
            .map($.proxy(createPlaceholdersListGroup, this))
            .join('');
    }

    function createPlaceholdersListGroup(group) {
        return [
            '<li class="item-header">', group.title, '</li>',
            (group.children || [])
                .map($.proxy(createPlaceholdersListItem, this))
                .join('')
        ].join('');
    }

    function sortByPositionAndTitle(a, b) {
        if (a.position !== b.position) {
            return a.position - b.position;
        }

        return Tools.SortStringArray(a.title, b.title);
    }

    function createPlaceholdersListItem(placeholder) {
        const isSelected = placeholder === this.CurrentlySelectedPlaceholder;
        const isSearchResult = Tools.contains(this.SearchResult, placeholder.name, 'name');
        const nameIsSearchResult = isSearchResult && this.SearchRegExp.test(placeholder.name);
        let innerHtml = isSearchResult && !nameIsSearchResult ?
            placeholder.title.replace(this.SearchRegExp, '<span class="search-result">$1</span>') :
            placeholder.title;

        if (this.SearchRegExp) {
            this.SearchRegExp.lastIndex = 0;
        }

        if (nameIsSearchResult) {
            innerHtml = '<span class="search-result">' + placeholder.title + '</span>';
        }

        return isSelected ?
            '<li class="selected" data-name="{0}" draggable="true">{1}</li>'.format(placeholder.name, innerHtml) :
            '<li data-name="{0}" draggable="true">{1}</li>'.format(placeholder.name, innerHtml);
    }

    function onClickPlaceholdersListItem(evt) {
        const $this = $(evt.currentTarget);
        const name = $this.data('name').toLowerCase();

        this.CurrentlySelectedPlaceholder = this.PlaceHoldersMap[name];

        this.$placeHoldersList.children('.selected').removeClass('selected');
        $this.addClass('selected');

        const placeholderDescription = getPlaceholderDescriptionMarkup.call(this);

        this.$placeHoldersDescription.html(placeholderDescription);
    }

    function getPlaceholderDescriptionMarkup() {
        const html = [];

        if (this.CurrentlySelectedPlaceholder) {
            html.push(
                '<h4>', this.CurrentlySelectedPlaceholder.title, '</h4>',
                this.CurrentlySelectedPlaceholder.description || ''
            );
        }

        return html.join('');
    }

    function selectPlaceholdersSearchResult(selectedResult) {
        const idx = (selectedResult || 1) - 1;

        if (idx >= this.SearchResult.length) {
            return;
        }

        const selectedSearchResult = this.SearchResult[idx];
        const $children = this.$placeHoldersList.children();
        const $selectedSearchResult = $children.filter(`[data-name="${selectedSearchResult.name}"]`);

        $children
            .filter('.selected-search-result')
            .removeClass('selected-search-result');

        $selectedSearchResult.addClass('selected-search-result');
        $selectedSearchResult.get(0).scrollIntoView();
    }

    function onSearchFunction(_event, data) {
        const searchText = (data.input || '')
            .trim()
            .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');

        if (searchText) {
            this.SearchRegExp = new RegExp(`(${searchText})`, 'ig');

            this.SearchResult = Object.values(this.PlaceHoldersMap)
                .filter(function (fn) {
                    this.SearchRegExp.lastIndex = 0;

                    return this.SearchRegExp.test(fn.title) || this.SearchRegExp.test(fn.name);
                }, this)
                .sort(sortByPositionAndTitle);

            this.Search.setResultCount(this.SearchResult.length);
        } else {
            this.SearchRegExp = null;
            this.SearchResult = [];
            this.Search.setResultCount(0);
        }

        const listMarkup = getPlaceholdersListMarkup.call(this);

        this.$placeHoldersList.html(listMarkup);

        selectPlaceholdersSearchResult.call(this);
        bindEvents.call(this);
    }

    function onSelectPreviousOrNextFunction(_event, data) {
        selectPlaceholdersSearchResult.call(this, data.selectedResult);
    }

    function resizeWindow() {
        const screenHeight = $(window).height();
        let height = 600;

        if ((screenHeight - 40) < height) {
            height = screenHeight - 40;
        }

        this.$window.css({
            height: height,
            'margin-top': -((height + 20) / 2)
        });
    }

    function close() {
        this.$window.remove();

        unbindEvents.call(this);
    }

    MailTemplatePlaceholdersWindow.prototype.Show = show;
    MailTemplatePlaceholdersWindow.prototype.Close = close;

    if (!global.System) {
        global.System = {};
    }

    global.System.MailTemplatePlaceholdersWindow = MailTemplatePlaceholdersWindow;
})(Modifications.Popups || (Modifications.Popups = {}));